// From https://github.com/fnando/i18n/blob/3a6bbce72dd8988ad6a8c0286694703a7a74a65d/src/helpers/interpolate.ts#L4
import { I18n, TranslateOptions } from 'i18n-js'
import lodashGet from 'lodash.get'
import camelcase from 'camelcase'

/**
 * This function interpolates the all variables in the given message.
 *
 * @private
 *
 * @param {I18n} i18n The I18n instance.
 *
 * @param {string} message The string containing the placeholders.
 *
 * @param {object} options The source object that will be used as the
 * placeholders' source.
 *
 * @returns {string} The interpolated string.
 */
export function interpolate(i18n: I18n, message: string, options: TranslateOptions): string {
  options = Object.keys(options).reduce((buffer, key) => {
    buffer[i18n.transformKey(key)] = options[key]
    return buffer
  }, {} as TranslateOptions)

  const matches = message.match(i18n.placeholder)

  if (!matches) {
    return message
  }

  while (matches.length) {
    let value: string
    const placeholder = matches.shift() as string
    const name = placeholder.replace(i18n.placeholder, '$1')

    const option = lodashGet(options, name)
    const optionCamelCase = lodashGet(
      options,
      name.split('.').map(v => camelcase(v)),
    )

    if (option !== undefined && option !== null) {
      value = option.toString().replace(/\$/gm, '_#$#_')
    } else if (optionCamelCase !== undefined && optionCamelCase !== null) {
      value = optionCamelCase.toString().replace(/\$/gm, '_#$#_')
    } else if (name in options) {
      value = i18n.nullPlaceholder(i18n, placeholder, message, options)
    } else {
      value = i18n.missingPlaceholder(i18n, placeholder, message, options)
    }

    const regex = new RegExp(placeholder.replace(/\{/gm, '\\{').replace(/\}/gm, '\\}'), 'g')

    message = message.replace(regex, value)
  }

  return message.replace(/_#\$#_/g, '$')
}
